import styles from './_index.module.scss';

const NarrativesCanvas = () => {
  return <div className={styles['narratives-chat-canvas']}>CANVAS</div>;
};

export default NarrativesCanvas;
